{"clientToken":"pubfa68b973da1aca105f4df75fc051008c","applicationKey":"ebbb86f22e1eed2b75a03b2bca29a036f8f4b245"}